var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('project-locations-manual',{attrs:{"project-id":_vm.project.id,"is-admin-locations":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }